<script lang="ts">
	import HeroSection from '$lib/flexible/HeroSection.svelte'
	import OneCol from '$lib/flexible/OneCol.svelte'
	import TwoCol from '$lib/flexible/TwoCol.svelte'
	import TwoColImage from '$lib/flexible/TwoColImage.svelte'
	import TwoColProduct from '$lib/flexible/TwoColProduct.svelte'
	import VerticalTabs from '$lib/flexible/VerticalTabs.svelte'
	import SimpleBanner from '$lib/flexible/SimpleBanner.svelte'
	import LocationMap from '$lib/flexible/LocationMap.svelte'
	import FAQ from '$lib/flexible/FAQ.svelte'
	import HalfIconBanner from '$lib/flexible/HalfIconBanner.svelte'
	import HTML from '$lib/flexible/HTML.svelte'
	import ColsBanner from '$lib/flexible/ColsBanner.svelte'
	import JobOffers from '$lib/flexible/JobOffers.svelte'
	import ReturnCase from '$lib/components/returns/ReturnCase.svelte'
	import TrackOrder from '$lib/flexible/TrackOrder.svelte'
	import ProductsSlider from '$lib/components/ProductsSlider.svelte'
	import TwoColBanner from '$lib/flexible/blocks/TwoColBanner.svelte'
	import FiguresBlock from '$lib/flexible/FiguresBlock.svelte'
	import { is_set_object } from '$lib/js/helpers'
	import { page } from '$app/stores'
	import type { FlexibleComponent } from '$lib/js/strapi/types'
	import '$lib/css/components/u-text.scss'

	let page_data: {
		hero_section: HeroSection
		components: FlexibleComponent[]
	} = $page.data.page_data
</script>

{#if is_set_object(page_data)}
	<div class="u-text">
		<HeroSection component={page_data.hero_section} />

		<div class="container">
			<div class="flexible-components">
				{#each page_data.components as component, index}
					{#if component.__component === 'pages.one-col'}
						<div style="order: {index + 1}">
							<OneCol {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.two-col'}
						<div style="order: {index + 1}">
							<TwoCol {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.two-col-image'}
						<div style="order: {index + 1}">
							<TwoColImage {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.two-col-product'}
						<div style="order: {index + 1}">
							<TwoColProduct {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.vertical-tabs'}
						<div style="order: {index + 1}">
							<VerticalTabs {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.simple-banner'}
						<div style="order: {index + 1}">
							<SimpleBanner {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.location-map'}
						<div style="order: {index + 1}">
							<LocationMap {component} />
						</div>
					{/if}

					{#if component.__component === 'common.faq'}
						<div style="order: {index + 1}">
							<FAQ faq={component} />
						</div>
					{/if}

					{#if component.__component === 'pages.half-icon-banner'}
						<div style="order: {index + 1}">
							<HalfIconBanner {component} />
						</div>
					{/if}

					{#if component.__component === 'common.html'}
						<div style="order: {index + 1}">
							<HTML {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.cols-banner'}
						<div style="order: {index + 1}">
							<ColsBanner {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.job-offers'}
						<div style="order: {index + 1}">
							<JobOffers {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.two-col-banner'}
						<div style="order: {index + 1}">
							<TwoColBanner {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.return'}
						<div style="order: {index + 1}">
							<ReturnCase {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.track-order'}
						<div style="order: {index + 1}">
							<TrackOrder {component} />
						</div>
					{/if}

					{#if component.__component === 'pages.product-slider' && $page?.data?.products_slider.filter((el) => el.id === component.id)[0].prods}
						<div class="products-slider" style="order: {index + 1}">
							<ProductsSlider
								title={component.title}
								description={component.subtitle}
								products={$page?.data?.products_slider.filter((el) => el.id === component.id)[0].prods}
							/>
						</div>
					{/if}

					{#if component.__component === 'pages.figures-block'}
						<div style="order: {index + 1}">
							<FiguresBlock {component} />
						</div>
					{/if}
				{/each}
			</div>
		</div>
	</div>
{/if}

<style lang="scss">
	.products-slider {
		margin-bottom: 40px;
	}
	.flexible-components {
		display: flex;
		flex-direction: column;
		margin-top: 30px;
		margin-bottom: 60px;

		@media (min-width: 769px) {
			margin-top: 20px;
			margin-bottom: 100px;
		}
	}
</style>
